var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_3212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39453 0H13.6055C16.0259 0 18 1.97409 18 4.39453V13.6055C18 16.0259 16.0259 18 13.6055 18H4.39453C1.97409 18 0 16.0259 0 13.6055V4.39453C0 1.97409 1.97409 0 4.39453 0ZM7.75304 8.34877L6.77753 7.37364H13.2359V5.70565H6.77753L7.75304 4.73052L6.57352 3.55057L3.58457 6.54015L6.57352 9.52872L7.75304 8.34877ZM11.4264 8.47128L10.247 9.65039L11.2225 10.6265H4.76402V12.2945H11.2225L10.247 13.2696L11.4264 14.4496L14.4154 11.46L11.4264 8.47128Z",
    fill: "#7A7B93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_3212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsIcon);
export default __webpack_public_path__ + "static/media/DirectionsIcon.f69b77b63dde66c8a70a32f5814ba78d.svg";
export { ForwardRef as ReactComponent };